/**
     * @desc 查询ConferenceRecordingStatus
可能产生业务错误码：510001、510002、511005、
     */

import * as SWR from 'swr';

import * as defs from '../../baseClass';
import * as Hooks from '../../../hooks';
import { PontCore } from '../../../pontCore';

export class Params {
  /** channelId */
  channelId: number;
}

export const method = 'GET';

export function mutate(
  params = {},
  newValue = undefined,
  shouldRevalidate = true,
) {
  return SWR.mutate(
    Hooks.getUrlKey('/api/bs-vmeeting/web/v3/meeting/recording', params, 'GET'),
    newValue,
    shouldRevalidate,
  );
}

export function useRequest(params = {}, swrOptions = {}) {
  return Hooks.useRequest(
    '/api/bs-vmeeting/web/v3/meeting/recording',
    params,
    swrOptions,
  );
}

export function request(params: Params, options?: any) {
  return PontCore.fetch(
    PontCore.getUrl('/api/bs-vmeeting/web/v3/meeting/recording', params, 'GET'),
    {
      method: 'GET',

      ...options,
    },
  );
}
